import {node} from "../../constants";
import React from "react";
import {p0, p1, p2, p4, p8, p16} from "../../pl_commons";
import PlIcon from "../pl_icon";
import {baseline, baseline_turn, bm_left, bm_right, bm_turn} from "./icon_commons";
import {is_bus_available} from "./plan_commons";
import {uidEqual} from "../../../../bidib/bidib_commons";


const SwIcon = ({item, bidib}) => {

    const[hover, setHover] = React.useState(false);

    const a = bidib.find(it => uidEqual(it.uid, item.addr) )
    const avail = !!(a && a.available)

    // ACC
    let busstate = item.accessorystate === "0" ? node.STRAIGHT : node.TURNOUT
    const buswait = parseInt(item.accessorywait)

    if( !item.addr || item.addr === "") {
        busstate = item.virtual_state
    }

    let strokecolor = '#777777'

    let inroute = item.lockid && item.lockid !== ""
    let rtcolor = inroute ? '#fff44f' : '#E0E0E0'

    if( item.fbaddr !== "NA" ){//&& item.fbstat === undefined) {
     //   strokecolor = '#ffbcf9'
        //rtcolor = strokecolor
    }

    let bmstate = item.fbstat === "true"

    if( item.bm_route_only && bmstate && inroute) {
        rtcolor = '#ff0000';
    } else if( bmstate && !item.bm_route_only ) {
        rtcolor = '#ff0000';
    }




    let turnoutcolor = busstate === node.TURNOUT ? rtcolor : strokecolor // rtcolor
    let straightcolor = busstate === node.STRAIGHT ? rtcolor : strokecolor // rtcolor

    var blinkstate = ''
    if (buswait) {
        blinkstate = busstate
        turnoutcolor = strokecolor
        straightcolor = strokecolor
    } else {
        blinkstate = '';
    }

    var turnoutanimate = ""
    var straightanimate = ""

    if (blinkstate === node.TURNOUT) {
        turnoutanimate = <animate
            attributeType="XML"
            attributeName="stroke"
            values="#e7ee11;#777777;#e7ee11;#e7ee11;"
            dur="1s"
            repeatCount="indefinite"/>
    } else if (blinkstate === node.STRAIGHT) {
        straightanimate = <animate
            attributeType="XML"
            attributeName="stroke"
            values="#e7ee11;#777777;#e7ee11;#e7ee11;"
            dur="1s"
            repeatCount="indefinite"/>
    }

    var line = [];

    if( item.subtype === 'aussen') {

        // Click area
        line.push(
            <rect key={'rxx'} x={0} y={0} width={p1} height={p1} fillOpacity={0}
                  onMouseEnter={() => setHover( true)} onMouseLeave={() => setHover(false)}/>
        )

        line.push(<circle key={"c1yy"} cx={p2} cy={p2} r={p8} stroke= {'#0d327e'} strokeWidth="1" fill={hover?'#3e70d8':'#1d4aa8'}/>)
    } else if( item.subtype === 'taster') {

        // Click area
        line.push(
            <rect key={'rxx'} x={0} y={0} width={p1} height={p1} fillOpacity={0}
                  onMouseEnter={() => setHover( true)} onMouseLeave={() => setHover(false)}/>
        )

        const color = hover ? busstate === node.TURNOUT ? '#662222':'#226622' : busstate === node.TURNOUT ? '#882222':'#228822'

        line.push(<circle key={"c1yy"} cx={p2} cy={p2} r={p8} stroke= {"#333333"} strokeWidth="1" fill={color}/>)
    } else {

        // gerade
        line.push(baseline(avail));

        // abzweig
        line.push(baseline_turn(avail));

        // gerade
        line.push(bm_left({avail: avail, stroke: straightcolor, animate: straightanimate}));
        line.push(bm_right({avail: avail, stroke: straightcolor, animate: straightanimate}));

        // abzweig
        line.push(bm_turn({avail: avail, stroke: turnoutcolor, animate: turnoutanimate}));
    }


    let transform = "rotate(0,0,0)";
    if (item.ori === "east") {
        transform = "rotate(180,0,0)";
    }
    if (item.subtype === "right") {
        transform += "scale(1, -1)";
    }

    return(
        <PlIcon item={item} transform={transform}>
            {line}
        </PlIcon>
    )
}


export default SwIcon